import React from 'react';

import {
  OfferReviewDialog,
  PurchaseButton,
  OfferCardStatusEnum,
} from '@wwe-portal/ui/features/offer';

import { useStepupContext } from './context/stepup-context';
import { parseOfferPreview } from '../club-store/modals/OfferPreviewDialog';
import { parseRegionalOfferPrice } from '@wwe-portal/web/utils/offer/mapper';

export const OfferPreviewDialog = () => {
  const { isPaying, focusedOffer, validatePurchase, closeReviewModal } =
    useStepupContext();

  const offerData = focusedOffer?.offer.offerData;
  const stepupOffer = focusedOffer?.offer;

  if (!focusedOffer || !offerData || !stepupOffer) return <></>;
  const isDisabled = focusedOffer.props.status === OfferCardStatusEnum.LOCKED;

  const getActionBtn = () => {
    const price = parseRegionalOfferPrice(offerData);
    return (
      <PurchaseButton
        onClick={() => validatePurchase({})}
        loading={isPaying}
        className="w-full"
        price={price.price}
        disabled={isDisabled}
      >
        {isDisabled
          ? `Purchase item ${focusedOffer.props.orderId - 1} to unlock`
          : undefined}
      </PurchaseButton>
    );
  };

  const handleClose = () => {
    closeReviewModal();
  };

  return (
    <OfferReviewDialog
      open
      onClose={handleClose}
      data={{ ...parseOfferPreview(offerData, getActionBtn()) }}
      className="z-stepups"
      overlayProps={{
        className: 'z-stepups',
      }}
    />
  );
};
